export const URL_AXIOS="https://modele2.e-metech.com/api/";
export const URL_FOLDER_API="https://modele2.e-metech.com/sites/";
export const URL_ENTETE_SITE="https://modele2.e-metech.com/sites/";
export const URL_MAIN="https://modele2.e-metech.com/";